import * as RX from 'reactxp';
import Form from './Form';

import data from './CreateProjectData';

const countries: RX.Types.PickerPropsItem[] = [
    {
        label: "South Africa",
        value: "South Africa",
    },
    {
        label: "United States",
        value: "United States",
    },
    {
        label: "China",
        value: "China",
    }
];

RX.App.initialize(true, true);
RX.UserInterface.setMainView(<Form countries={countries} fields={data.fields}/>);
export default Form;



// WEBPACK FOOTER //
// ./src/index.tsx